var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Select,{ref:"selectRef",attrs:{"state-key":_vm.stateKey,"filterable":""},on:{"change":_setup.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }